import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/commmune-commonmistakes.png'

const paperInfo = {
  paperName: 'コミュニティ運営のよくある失敗と気をつけるべきポイント',
  thumbnail,
  feature1: 'コミュニティで起こる代表的な失敗3つ',
  feature2: '失敗を避けるために最も大事なこと',
  feature3: 'コミュニティを成功させる4つのポイント',
  description:
    'コミュニティは自社のユーザーを巻き込み、準備に時間もかかるため、「始めてみたものの失敗してしまった」という状態は絶対に避けたい施策です。コミュニティを成功させるための具体的な対策と運営の心得を解説します。',
  formSrc: 'https://go.commmune.jp/l/915341/2022-03-09/dxpl1',
  type: 'pardot' // TODO: HubSpotからPardotに移行したらこのタグ付けが不要になるので削除する
}

const WhitePaperPage = () => {
  return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
